import {
  IframeActionType,
  IframeState,
  SET_DEPOSIT_TRACKING,
  SET_FEEDBACK_IFRAME_SRC,
  SET_IS_ZENDESK_OPEN,
  SET_PAYMENT_IFRAME_DIALOG_URL,
  SET_REGISTRATION_TRACKING,
  SET_STREAM_BETRADAR_STATUS,
  SET_STREAM_IFRAME_EVENT_ID,
  SET_STREAM_IFRAME_SRC,
  SET_STREAMING_SUPPLIER,
} from '../types/iframeTypes';
import { RESET_STATE } from '../types/stateTypes';

export const initialIframeState: IframeState = {
  iframeSource: {
    payment: undefined,
    feedback: undefined,
    stream: {
      source: undefined,
      eventId: undefined,
    },
    depositTracking: false,
    registrationTracking: false,
    streamingSupplier: undefined,
    betradarStatus: undefined,
  },
  isZendeskOpen: false,
};

export const iframeReducer = (state = initialIframeState, action: IframeActionType): IframeState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialIframeState,
      };
    case SET_PAYMENT_IFRAME_DIALOG_URL: {
      return {
        ...state,
        iframeSource: {
          ...state.iframeSource,
          payment: action.meta,
        },
      };
    }
    case SET_FEEDBACK_IFRAME_SRC: {
      return { ...state, iframeSource: { ...state.iframeSource, feedback: action.meta } };
    }
    case SET_STREAM_IFRAME_SRC: {
      return {
        ...state,
        iframeSource: {
          ...state.iframeSource,
          stream: {
            ...state.iframeSource.stream,
            source: action.meta,
          },
        },
      };
    }
    case SET_STREAM_IFRAME_EVENT_ID: {
      return {
        ...state,
        iframeSource: {
          ...state.iframeSource,
          stream: {
            ...state.iframeSource.stream,
            eventId: action.meta,
          },
        },
      };
    }
    case SET_STREAMING_SUPPLIER: {
      return { ...state, iframeSource: { ...state.iframeSource, streamingSupplier: action.meta } };
    }
    case SET_STREAM_BETRADAR_STATUS: {
      return { ...state, iframeSource: { ...state.iframeSource, betradarStatus: action.meta } };
    }
    case SET_DEPOSIT_TRACKING: {
      return { ...state, iframeSource: { ...state.iframeSource, depositTracking: action.meta } };
    }
    case SET_REGISTRATION_TRACKING: {
      return { ...state, iframeSource: { ...state.iframeSource, registrationTracking: action.meta } };
    }
    case SET_IS_ZENDESK_OPEN: {
      return { ...state, isZendeskOpen: action.meta };
    }
    default:
      return state;
  }
};
